import FeedBack from '../../assets/feedback.jpg'
import FeedBack2 from '../../assets/feedback4.png'
import FeedBack3 from '../../assets/feedback3.jpeg'

export const Data = [
    {
      id: 1,
      image: FeedBack,
      title: "Сыймык Абдыкадыров",
      description:
        "Превосходная работа! Все было сделано в соответствии с договором, и то, что ещё более важно, все было сделано быстро.",
    },
    {
      id: 2,
      image: FeedBack2,
      title: "Эргазы (Эрдент)",
      description:
        "Действительно хорошая работа, все аспекты проекта были выполнены шаг за шагом и с хорошими результатами.",
    },
    {
      id: 3,
      image: FeedBack3,
      title: "Медербек Бегматов",
      description:
        "Хочу выразить благодарность за профессиональный подход к работе! Результаты превзошли все ожидания.",
    },
  ];